module.exports = new __parcel__URL__("graph-go-up-with-people.4705ad58.svg").toString();